import { IThresholdAlertBehavior } from "./IThresholdAlertBehavior";
import { ColorSpecifiedFeature } from "../../../../base/domain/drawing";

export class ThresholdAlertBehavior<T = number> implements IThresholdAlertBehavior<T> {
  constructor(
    public isEnable: boolean,
    public threshold: T,
    public alertByStyle: ColorSpecifiedFeature,
    ) {
  }

  clone(): ThresholdAlertBehavior<T> {
    return new ThresholdAlertBehavior(this.isEnable, this.threshold, this.alertByStyle.clone());
  }

  static from<T>(source: IThresholdAlertBehavior<T>): ThresholdAlertBehavior<T> {
    return new ThresholdAlertBehavior(source.isEnable, source.threshold, ColorSpecifiedFeature.from(source.alertByStyle));
  }

  static to<T>(source: ThresholdAlertBehavior<T>): IThresholdAlertBehavior<T> {
    return {
      isEnable: source.isEnable,
      threshold: source.threshold,
      alertByStyle: ColorSpecifiedFeature.to(source.alertByStyle),
    };
  }
}
